import React, {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import Layout from "../../../Layout";
import API_ROUTES from "../../../api-routes";
import apiService from "../../../services/service";
import { Link, Outlet, useNavigate, useParams } from "react-router-dom";
import ReactCountryFlag from "react-country-flag";
import { getName } from "country-list";
import OfficersSideBar from "./OfficersSideBar";
import { Skeleton } from "primereact/skeleton";
import { useDispatch } from "react-redux";
import { fetchEntityDetail } from "~/components/global-entities/globalEntitiesSlice";

const OfficerContext = createContext();

const OfficerDetails = ({ type }) => {
  const { id: officerId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [regData, setRegData] = useState({});
  const [loading, setLoading] = useState(true);
  let initialOfficerData = useRef({});

  useEffect(() => {
    fetchOfficerData();
  }, []);

  const fetchOfficerData = async () => {
    setLoading(true);
    const { data } = await apiService(API_ROUTES.FETCH_OFFICER, "GET", {
      replace: { id: officerId },
    });
    dispatch(fetchEntityDetail(data?.entityData?.id));
    setRegData(data);
    setLoading(false);
    initialOfficerData.current = data;
  };

  const resetRegData = (data = {}) => {
    const mergedData = {
      ...initialOfficerData.current,
      ...data,
    };
    setRegData(mergedData);
  };

  const breadcrumbs = [
    {
      label: <span className="breadcrumb-link">My Entities</span>,
      command: () => navigate("/entities"),
      id: "entities",
    },
    {
      label: (
        <Link
          to={`/entity/${regData.entityData?.id}/dashboard`}
          className="link__style flex"
        >
          {!loading ? (
            regData.entityData?.name
          ) : (
            <Skeleton width="100px" height="20px" className="mr-1" />
          )}
          {!loading ? (
            " "
          ) : (
            <Skeleton width="10px" height="20px" className="mr-1" />
          )}
          {!loading ? (
            <>
              (
              <ReactCountryFlag
                countryCode={regData.entityData?.country || ""}
                svg
                className=""
              />{" "}
              {getName(regData.entityData?.country || "")})
            </>
          ) : (
            <Skeleton width="150px" height="20px" className="mr-1" />
          )}
        </Link>
      ),
      id: "entity",
    },
    {
      label: <span className="breadcrumb-link">Appointments & Ownership</span>,
      command: () =>
        navigate(
          type === "officer"
            ? `/entity/${regData.entityData?.id}/appointments-ownership?tab=officers`
            : `/entity/${regData.entityData?.id}/appointments-ownership?tab=power-of-attorney`,
        ),
      id: "officer-data",
    },
    {
      label: (
        <>
          {!loading ? (
            `${regData.name} ${regData.last_name}`
          ) : (
            <Skeleton width="100px" height="20px" className="mr-1" />
          )}
        </>
      ),
    },
  ];

  return (
    <OfficerContext.Provider
      value={{ regData, setRegData, resetRegData, loading, type }}
    >
      <Layout crumbs={breadcrumbs}>
        <div className="grid grid-nogutter">
          <div className="col-12 Entities-container">
            <div className="grid">
              <div className="col-3">
                <OfficersSideBar type={type} />
              </div>
              <div className="col-9">
                <Outlet />
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </OfficerContext.Provider>
  );
};

export default OfficerDetails;
export const useOfficerDetails = () => useContext(OfficerContext);
